import { useState, useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import styles from "./brandNewCar.module.scss";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { BrandNewCarProps } from "../../interfaces/components";
import StepPictures from "./StepPictures/StepPictures";
import StepInfo from "./StepInfo/StepInfo";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { bindActionCreators, Dispatch } from "@reduxjs/toolkit";
import PriceContainer from "../../containers/Sell/PriceContainer";
import StepPicturesContainer from "../../containers/Sell/StepPicturesContainer";
import Button from "../Button/Button";


interface ExtendedBrandNewCarProps extends BrandNewCarProps {
    postPublicationBrand?: Function;
    postPublicationsBrandImages?: Function;
}


interface MainInfoData {
    brandId: string | number;
    brandName: string;
    modelId: string | number;
    modelName: string;
    cantidadVersiones: number;
    mainImage: string | null;
}

interface VersionData {
    version?: { name?: string };
    year?: string | number;
    price?: string | number;
    fuel?: string;
    transmission?: string;
    doors?: string | number;
    type?: string;
    selectedAdditionalCharacters?: any[];
    imagesVideos?: any[];
    pictures?: string[]; 
}


const BrandNewCar= ({ 
    user,
    adminBrand,
    getAdminBrand,
    children, 
    isPatentFound = false, 
    vehicleData,
    getBrands,
    cleanGetBrands,
    setBrand,
    getModels,
    cleanGetModels,
    setModel,
    getVersions,
    getYears,
    cleanGetYears,
    brands,
    models,
    versions,
    years,
    fetchingVersions,
    accidentsReported,
    personalUse,
    soleOwner,
    isFoundPlate,
    request_id, 
    getSuggestedPrice,
    setRecord,
    kms,
    setKms,
    setFuel,
    setColor,
    setYear,
    color,
    fuel, 
    version,
    setVersion,
    year,
    plate,
    vehicleType,
    setType,
    transmission,
    setTransmission,
    doors,
    setDoors,
    cleanGetVersions,
    getAdditionalCharacters,
    additionalCharacters,
    setAdditionalCharacters,
    setSelectedAdditionalCharacters,
    selectedAdditionalCharacters,
    setRegion,
    region,
    getRegions,
    regions,
    postPublicationBrand,
    postPublicationsBrandImages
}: ExtendedBrandNewCarProps) => {
    const [expanded, setExpanded] = useState<string | false>('panel1');
    const [completedSteps, setCompletedSteps] = useState<string[]>([]);
    const location = useLocation();
    const [isStep1Valid, setIsStep1Valid] = useState(false);
    const [isStep2Valid, setIsStep2Valid] = useState(false);
    const [cantidadVersiones, setCantidadVersiones] = useState(1);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [versionsData, setVersionsData] = useState<VersionData[]>([]);
    const [mainInfo, setMainInfo] = useState<MainInfoData | null>(null);
    const navigate = useNavigate();
    
    
    const [versionImages, setVersionImages] = useState<{[versionIndex: number]: any[]}>({});
    const [versionValidities, setVersionValidities] = useState<{[versionIndex: number]: boolean}>({});
    
    
    const [hasInitialized, setHasInitialized] = useState(false);
    
 
    const handleVersionImagesChange = (versionIndex: number, images: any[]) => {
        setVersionImages(prev => ({
            ...prev,
            [versionIndex]: images
        }));
    };
    
    const handleVersionValidityChange = (versionIndex: number, isValid: boolean) => {
        setVersionValidities(prev => ({
            ...prev,
            [versionIndex]: isValid
        }));
    };
    

    const cleanVersionData = (versionIndex: number) => {
      
        setVersionImages(prev => {
            const newImages = { ...prev };
            delete newImages[versionIndex];
            return newImages;
        });
        
       
        setVersionValidities(prev => {
            const newValidities = { ...prev };
            delete newValidities[versionIndex];
            return newValidities;
        });
        
        
        try {
            localStorage.removeItem(`linze_real_image_ids_version_${versionIndex}`);
         
        } catch (error) {
            console.error('Error al limpiar datos de versión:', error);
        }
    };

    const handlePublishCars = async () => {
        if (!mainInfo) return;
        
        setIsSubmitting(true);
        
        try {
            const publicationData = {
                brand: mainInfo.brandName,
                brand_id: mainInfo.brandId,
                model: mainInfo.modelName,
                model_id: mainInfo.modelId,
                pictures: mainInfo.mainImage ? mainInfo.mainImage : [],
                article: versionsData.map(versionData => ({
                    version: versionData.version?.name || '',
                    year: versionData.year || '',
                    price: versionData.price || '',
                    fuel: versionData.fuel || '',
                    transmission: versionData.transmission || '',
                    doors: versionData.doors || '',
                    type: versionData.type || 'Vehículo',
                    additional_characters: versionData.selectedAdditionalCharacters || [],
                    pictures: versionData.pictures || []
                }))
            };
            
            if (postPublicationBrand) {
                try {
                    const response = await postPublicationBrand(publicationData);
                    
                    if (response && response.success) {
                        try {
                            const keysToRemove = [];
                            for (let i = 0; i < localStorage.length; i++) {
                                const key = localStorage.key(i);
                                if (key && key.startsWith('linze_real_image_ids_version_')) {
                                    keysToRemove.push(key);
                                }
                            }
                            keysToRemove.forEach(key => localStorage.removeItem(key));
                            
                            navigate('/profile/my_publications_brand');
                        } catch (error) {
                            navigate('/profile/my_publications_brand');
                        }
                    } else {
                        console.log('Hubo un error al publicar el vehículo. Por favor, inténtalo de nuevo.');
                    }
                } catch (error) {
                    console.error('Error al publicar el vehículo:', error);
                  
                }
            }
        } catch (error) {
            console.error('Error al publicar vehículo de marca:', error);
        } finally {
            setIsSubmitting(false);
        }
    };

    useEffect(() => {
        const fromDetail = localStorage.getItem('linzeReturnFromDetail');
        if (fromDetail === 'true') {
            setCompletedSteps([]);
            setExpanded('panel1')
          localStorage.removeItem('linzeReturnFromDetail');
        }
      }, []);
      

    const handleChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
        setExpanded(isExpanded ? panel : false);
    };

    const handleVersionsChange = (cantidad: number) => {
        setCantidadVersiones(cantidad);
    };

    const handleDeleteVersion = (versionIndex: number) => {
        if (cantidadVersiones > 1) {
            setCantidadVersiones(prev => prev - 1);

            const panelToDelete = `panel${versionIndex + 2}`;
            if (expanded === panelToDelete) {
                if (versionIndex === 0) {

                    setExpanded('panel2');
                } else {
      
                    setExpanded('panel2');
                }
            }
  
            setCompletedSteps(prev => prev.filter(step => {
                const stepNumber = parseInt(step.replace('panel', ''));
                if (stepNumber === 1) return true;
                
                const versionNum = stepNumber - 1;
                return versionNum !== versionIndex + 1;
            }));
            
            
            cleanVersionData(versionIndex);
            
            
            const newVersionImages: {[key: number]: any[]} = {};
            const newVersionValidities: {[key: number]: boolean} = {};
            
            Object.keys(versionImages).forEach(key => {
                const oldIndex = parseInt(key);
                if (oldIndex < versionIndex) {
                    newVersionImages[oldIndex] = versionImages[oldIndex];
                    newVersionValidities[oldIndex] = versionValidities[oldIndex];
                } else if (oldIndex > versionIndex) {
                    newVersionImages[oldIndex - 1] = versionImages[oldIndex];
                    newVersionValidities[oldIndex - 1] = versionValidities[oldIndex];
                    try {
                        const oldKey = `linze_real_image_ids_version_${oldIndex}`;
                        const newKey = `linze_real_image_ids_version_${oldIndex - 1}`;
                        const data = localStorage.getItem(oldKey);
                        if (data) {
                            localStorage.setItem(newKey, data);
                            localStorage.removeItem(oldKey);
                        }
                    } catch (error) {
                        console.error('Error al reorganizar localStorage:', error);
                    }
                }
            });
            setVersionsData(prev => {
                const newData = [...prev];
                newData.splice(versionIndex, 1);
                return newData;
              });
            setVersionImages(newVersionImages);
            setVersionValidities(newVersionValidities);
        }
    };

    const areAllStepsComplete = () => {
        const requiredPanels = ['panel1']; // Paso 1 siempre
        for (let i = 0; i < cantidadVersiones; i++) {
          requiredPanels.push(`panel${i + 2}`);
        }
        return requiredPanels.every(panel => completedSteps.includes(panel));
      };
      

      const handleAddVersion = () => {
        const lastVersionIndex = cantidadVersiones - 1;
        const isLastVersionValid = versionValidities[lastVersionIndex];
    
        const newVersionNumber = cantidadVersiones + 1;
        const newPanelId = `panel${newVersionNumber + 1}`;
        setCantidadVersiones(newVersionNumber);
    
        if (isLastVersionValid) {
            setExpanded(newPanelId);
        } else {
            setExpanded(false);
        }
    };
    
    

    const renderVersionAccordions = () => {
       
        
        if (!completedSteps.includes('panel1')) return null;

        const accordions = [];
        for (let i = 0; i < cantidadVersiones; i++) {
            const panelId = `panel${i + 2}`;
            const versionNumber = i + 1;
            const isFirstVersion = i === 0;


            accordions.push(
                <Accordion 
                    key={panelId} 
                    expanded={expanded === panelId} 
                    onChange={(event, isExpanded) => {
                    
                        if (i === 0 || versionValidities[i - 1]) {
                          handleChange(panelId)(event, isExpanded);
                        }
                      }}
                    className={styles.accordion}
                >
                    <AccordionSummary
                        expandIcon={<span style={{ color: '#7100FF', fontSize: '15px', marginRight: '10px' }}>
                            {expanded === panelId ? 
                                <span 
                                    style={{ color: isFirstVersion ? '#484848' : '#B3261E', fontSize: '14px', cursor: isFirstVersion ? 'default' : 'pointer' }}
                                    onClick={!isFirstVersion ? (e) => {
                                        e.stopPropagation();
                                        handleDeleteVersion(i);
                                    } : undefined}
                                >
                                    {isFirstVersion ? '2/2' : 'Eliminar sección'}
                                </span> : 'Editar'}
                        </span>}
                        className={styles.accordionSummary}
                    >
                        <div className={styles.stepHeader}>
                            {expanded !== panelId && (
                                <span className={`${styles.stepNumber} ${completedSteps.includes(panelId) ? styles.completed : ''}`}>
                                    {completedSteps.includes(panelId) && (
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z" fill="currentColor"/>
                                        </svg>
                                    )}
                                    Paso {2}
                                </span>
                            )}
                            <h3>Versión {versionNumber}</h3>
                            
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <StepPictures
                            postPublicationsImages={postPublicationsBrandImages || (() => {})} 
                            deletePublicationImage={() => {}} 
                            plate={""} 
                            isFoundPlate={false} 
                            fetchingDeleteImage=""
                            cleanDeleteImage={() => {}}
                            imagesVideos={Array.isArray(versionImages[i]) ? versionImages[i] : []}
                            setImages={(images: any[]) => handleVersionImagesChange(i, images)} 
                            files={[]}
                            versionIndex={i} 

                            setYear={setYear || (() => {})}
                            fuel={vehicleData?.fuel || ''}
                            version={vehicleData?.version_id ? {
                                id: vehicleData.version_id,
                                name: vehicleData.version_name
                            } : null}
                            versions={versions || []}
                            getVersions={getVersions}
                            getYears={getYears}
                            years={years}
                            cleanGetYears={cleanGetYears}
                            fetchingVersions="unknown"
                            cleanGetVersions={cleanGetVersions}
                            getAdditionalCharacters={getAdditionalCharacters}
                            additionalCharacters={additionalCharacters}
                            setSelectedAdditionalCharacters={setSelectedAdditionalCharacters ?? (() => {})}
                            selectedAdditionalCharacters={selectedAdditionalCharacters}
                            setAdditionalCharacters={setAdditionalCharacters}
                            setVersion={setVersion}
                            setFuel={setFuel}
                            year={vehicleData?.year || 0}
                            vehicleType={vehicleData?.vehicle_type || ''}
                            setType={setType}
                            transmission={vehicleData?.transmission || ''}
                            setTransmission={setTransmission}
                            setDoors={setDoors}
                            doors={vehicleData?.doors || 5}
                            onValidityChange={(isValid: boolean) => {
                                handleVersionValidityChange(i, isValid);
                                
                                const allVersionsValid = Object.values({...versionValidities, [i]: isValid}).every(valid => valid);
                                setIsStep2Valid(allVersionsValid);
                            }}
                            onContinue={(versionData: VersionData) => {
                                setCompletedSteps(prev => [...prev, panelId]);
                                const nextPanel = `panel${i + 3}`;
                                
                                setVersionsData(prev => {
                                    const newData = [...prev];
                                    newData[i] = versionData;
                                    return newData;
                                });
                                
                                if (i + 1 < cantidadVersiones) {
                                    setExpanded(nextPanel);
                                }else {
                                   
                                    setExpanded(false);
                                  }
                            }}
                        />
                    </AccordionDetails>
                </Accordion>
            );
        }

        return accordions;
    };

    useEffect(() => {
        getAdditionalCharacters();
    }, [getAdditionalCharacters]);

    useEffect(() => {
        if (user?.profile?.code === "admin-brand" && adminBrand?.fetching === "unknown" && getAdminBrand) {
            (getAdminBrand as Function)();
        }
    }, [user?.profile?.code, adminBrand?.fetching, getAdminBrand]);

    useEffect(() => {
        if (user?.profile?.code === "admin-brand" && adminBrand?.fetching === "unknown") {
            (getAdminBrand as Function)();
        }
    }, [user, adminBrand?.fetching, getAdminBrand]);


    return (
        <div className={styles.searchContainer}>
            <h1 className={styles.pageTitle}>Vamos a publicar tus 0 km</h1>
            <div className={styles.sellModalContainer}>
                <div className={styles.accordionContainer}>
                    <Accordion 
                        expanded={expanded === 'panel1'} 
                        onChange={handleChange('panel1')} 
                        className={styles.accordion}
                    >
                        <AccordionSummary
                            expandIcon={<span style={{ color: '#7100FF', fontSize: '15px', marginRight: '10px' }}>
                                {expanded === 'panel1' ? <span style={{ color: '#484848', fontSize: '18px' }}>1/2</span> : 'Editar'}
                            </span>}
                            className={styles.accordionSummary}
                        >
                            <div className={styles.stepHeader}>
                                {expanded !== 'panel1' && (
                                    <span className={`${styles.stepNumber} ${completedSteps.includes('panel1') ? styles.completed : ''}`}>
                                        {completedSteps.includes('panel1') && (
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z" fill="currentColor"/>
                                            </svg>
                                        )}
                                        Paso 1
                                    </span>
                                )}
                                <h3>Información general del vehículo</h3>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <StepInfo
                                user={user}
                                adminBrand={adminBrand}
                                onValidityChange={(isValid: boolean) => setIsStep1Valid(isValid)}
                                onVersionsChange={handleVersionsChange}
                                cantidadVersiones={cantidadVersiones}
                                getModels={getModels}
                                cleanGetModels={cleanGetModels}
                                setModel={setModel}
                                getBrands={getBrands}
                                cleanGetBrands={cleanGetBrands}
                                setBrand={setBrand}
                                brands={brands}
                                models={models || { selected: null, fetching: 'idle', data: [] }}                          
                                postPublicationsBrandImages={postPublicationsBrandImages}
                                onContinue={(infoData: MainInfoData) => {
                                    setMainInfo(infoData);
                                    setCantidadVersiones(infoData.cantidadVersiones);
                                    setCompletedSteps(prev => [...prev, 'panel1']);
                                    setExpanded('panel2');
                                }}
                            />
                        </AccordionDetails>
                    </Accordion>

                    {renderVersionAccordions()}

                      {completedSteps.includes('panel1') && 
                        <div className={styles.bottomActions}>
                            <button 
                                className={styles.addVersionButton}
                                onClick={handleAddVersion}
                                type="button"
                            >
                                Agregar otra versión
                            </button>

                            <Button
                                onPress={handlePublishCars}
                                title={isSubmitting ? 'Publicando...' : 'Publica tus vehículos'}
                                primary
                                disabled={isSubmitting || !areAllStepsComplete()}
                                className={styles.continueButton}
                            />
                        </div>
                      }

                </div>
            </div>
        </div>
    );
};


    
export default BrandNewCar;